import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { ErrorView } from '../error-view';
import genericError from './assets/error-generic.svg';
import messages from './messages';

export const LimitReachedError = () => {
	const { formatMessage } = useIntl();

	return (
		<ErrorView
			title={formatMessage(messages.title)}
			description={formatMessage(messages.description)}
			image={<img src={genericError} width={80} height={105} alt="" />}
			testId="software-releases-approvers.common.ui.limit-reached-error.error-view"
		/>
	);
};
